import React from 'react';
import { Archive, ArchiveRestore, LogOut } from 'lucide-react';

export default function InvoiceActions({ workflow: w, children }) {
    return <footer className="esave-actions-bar" aria-label="Acciones de la gestión">
        <div className="esave-row-actions">
            <button data-tour="case-exit" className="esave-button" disabled={w.busy} onClick={() => w.leave()}><LogOut size={16} aria-hidden="true" />{w.dirty ? 'Salir sin guardar' : 'Cerrar gestión'}</button>
            <button data-tour="case-archive-current" className="esave-button" disabled={w.busy} onClick={() => w.archiveCase(w.record)}>{w.record.archived_at ? <ArchiveRestore size={16} aria-hidden="true" /> : <Archive size={16} aria-hidden="true" />}{w.record.archived_at ? 'Restaurar gestión' : 'Archivar gestión'}</button>
        </div>
        {children && <div className="esave-row-actions esave-actions-next">{children}</div>}
    </footer>;
}
